import React from 'react';
import { useFilters } from '@/hooks';
import { HeaderFilterTable, Icon, LabelLawyerState } from '@/components/common';
import { OptionsMultiple } from '@/components/ui/comboboxMultiple';
import { Options } from '@/components/ui/combobox';
import Icons from '@/const/icons';
import { useQuery } from '@tanstack/react-query';
import { casesLawyerService, GET_LAWYER_CASE_STATUSES } from '@/api';
import clsx from 'clsx';
import { useRouter } from 'next/router';

export const StatusFilter: React.FC = () => {
	const router = useRouter();
	const { page } = router.query;
	const [filters, setFilters] = React.useState<OptionsMultiple[]>([]);

	const { setParamFilter, hasFilter, removeParaFilter } = useFilters();

	const { data: caseStatuses } = useQuery({
		queryKey: [GET_LAWYER_CASE_STATUSES],
		queryFn: () => casesLawyerService.getCaseStatuses(),
	});

	React.useEffect(() => {
		if (!caseStatuses?.data) return;
		const initOptions: Options[] = [
			{
				label: 'View All',
				value: 'View All',
				icon: (
					<Icon
						src={Icons.list}
						width={18}
						height={18}
						className="text-primary"
					/>
				),
			},
		];

		const casesStatusList =
			caseStatuses?.data.map(({ id, name }, index) => ({
				value: `${id}`,
				label: (
					<span
						className={clsx('z-10', {
							'ml-0.5': index < 3,
							// "-ml-[1px]": index === 4
						})}
					>
						{name}
					</span>
				),
				icon: <LabelLawyerState status={name} withLabel={false} />,
			})) || [];

		const groupFilters: OptionsMultiple[] = [
			{
				title: '',
				options: initOptions,
			},
			{
				title: 'Case Status',
				options: casesStatusList,
			},
		];

		setFilters(groupFilters);
	}, [caseStatuses]);

	const handleSelectFilters = (key: string, value: string | undefined) => {
		key === 'Case Status'
			? setParamFilter('status', value, page as string)
			: removeParaFilter('status');
	};

	return (
		<HeaderFilterTable
			title="Status"
			filterOptions={filters}
			handleClearAll={undefined}
			handleSelectMultipleFilter={handleSelectFilters}
			hasFilter={hasFilter('status')}
			type="combo-multiple"
		/>
	);
};
